import React from "react";
import GenerateReports from "../../components/GenerateReports/GenerateReports";
import MysavedReports from "../../components/MySavedReports/MySavedReports";
import ReportCustomization from "../../components/ReportCustomization/ReportCustomization";

const Reports = () => {
    return (
        <div className="flex flex-col gap-4 p-4">
            <div className="flex w-full flex-col items-stretch gap-4 lg:flex-row lg:items-start lg:justify-between">
                <GenerateReports />
                <MysavedReports />
            </div>
            <ReportCustomization />
        </div>
    );
};

export default Reports;
